export const AUTH_COOKIES = {
  AffiliateCode: 'AffiliateCode',
};
